import queryString from 'querystring';
import { TOptionsQuery } from 'types/common';
import { TGetSurveyResult, TSurvey } from '../types/survey/survey';
import { axiosClient } from './axiosClient';

export const surveyApi = {
  getListSurvey: (params: TOptionsQuery<TSurvey>) => {
    const url = '/survey';
    const query = queryString.stringify(convertSurveyParam(params));

    return axiosClient.get(`${url}?${query}`);
  },
  getSurveyByFacility: (id: string) => {
    const url = `/survey/${id}`;
    return axiosClient.get(url);
  },
  getSurveyByGroup: ({ id, facilityIds }: { id: string; facilityIds: string[] }) => {
    const url = `/survey/get-group/${id}`;
    const query = facilityIds.map((item) => `facilityIds=${encodeURIComponent(item)}`).join('&');
    return axiosClient.get(`${url}?${query}`);
  },
  registerSurvey: (data: TSurvey) => {
    const url = '/survey';
    return axiosClient.post(url, data);
  },
  updateSurvey: (params: { id: string; data: TSurvey }) => {
    const url = `/survey/${params.id}`;
    return axiosClient.put(url, params.data);
  },
  deleteImplement: (id: string) => {
    const url = `/survey/${id}`;
    return axiosClient.delete(url);
  },
  getListEmployeeNotJoinSurvey: (surveyId: string) => {
    const url = `/survey/${surveyId}/employee-not-join`;
    return axiosClient.get(url);
  },
  getSurveyResult: (params: TOptionsQuery<TGetSurveyResult>) => {
    const url = '/survey-result';
    const query = queryString.stringify(params);
    return axiosClient.get(`${url}?${query}`);
  },
};

export const convertSurveyParam = (params: TOptionsQuery<TSurvey>) => {
  const { facilitysArr, ...restParams } = params;

  const serializableParams: any = { ...restParams };

  if (facilitysArr && facilitysArr.length > 0) {
    serializableParams.facilityIds = facilitysArr.map((facility) => facility.facilityId);
  }

  return serializableParams;
};
